import { useCallback } from 'react';
import { useErrorDialog } from '@ianesthesie-kit/redux';
import { useGenerateFullReport } from '@/modules/surgicalEvent';
import { appStore } from '@/store';
import {
  patchTriageEditable,
  setAllTriageEditable
} from '@/modules/appContext';
import { useAppDispatch, useCurrentPatientIdParam } from '@/hooks';
import type { InvertedDocumentMedium } from '@/modules/ui';

export const useCompleteReport = () => {
  const { showErrorDialog } = useErrorDialog();
  const dispatch = useAppDispatch();
  const patientId = useCurrentPatientIdParam();
  const [generatePdf, { isLoading }] = useGenerateFullReport({
    fixedCacheKey: `complete-report-gen-${patientId}`
  });

  const generate = useCallback(async (): Promise<
    InvertedDocumentMedium | undefined
  > => {
    if (!patientId) {
      return undefined;
    }
    const prevEditable = { ...appStore.getState().appContext.triage.editable };
    dispatch(setAllTriageEditable(false));
    try {
      const report = await generatePdf({ patientId }).unwrap();
      const medium = report.media?.[0];
      if (!medium) {
        return undefined;
      }
      return { ...medium, medicalDocument: report };
    } catch (error: any) {
      showErrorDialog(error);
      return undefined;
    } finally {
      dispatch(patchTriageEditable(prevEditable));
    }
  }, [dispatch, generatePdf, patientId, showErrorDialog]);

  return { generate, isLoading, enabled: !!patientId };
};
